export const RETAIL = 'Retail'
export const WHOLESALE = 'Wholesale'
export const ASSIGNED_TO_ME = 'Assigned To Me'
export const UNREAD_MESSAGES = 'Unread Messages'
export const UNAPPROVED_MESSAGES = 'Unapproved Messages'
export const UNANSWERED_MESSAGES = 'Unanswered Messages'
export const NO_PS_CONTRACTS = 'No P&S Contracts'
export const FLAGGED = 'Flagged'
